import React, { Component } from 'react';
import cn from 'classnames';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';
import ProductInfo from './ProductInfo';
import ProductName from './ProductName';
import ProductMeta from './ProductMeta';

export class Product extends Component<TParentComponentProps> {
  static defaultProps = {
    defaultClassName: 'cart-product',
  };

  static Info = ProductInfo;
  static Name = ProductName;
  static Meta = ProductMeta;

  render(): JSX.Element {
    const { defaultClassName, className, ...otherProps } = this.props;

    const tableClassName = cn({
      [defaultClassName]: !!defaultClassName,
      [className]: !!className,
    });

    return <ParentComponent className={tableClassName} {...otherProps} />;
  }
}

export default Product;
